var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "product-tile" }, [
    _c(
      "div",
      {
        staticClass: "product-tile__image-wrapper",
        on: { mouseover: _vm.hover, mouseleave: _vm.leave }
      },
      [
        !_vm.hovered
          ? _c("div", { staticClass: "product-tile__badge" }, [
              _vm.product.settings.labels.outStock && _vm.isOutStock
                ? _c("div", { staticClass: "product-tile__badge--out-stock" }, [
                    _vm._v("sold out")
                  ])
                : _vm.product.settings.labels.onSale && _vm.isOnSale
                ? _c("div", { staticClass: "product-tile__badge--sale" }, [
                    _vm._v("on sale")
                  ])
                : _vm.product.settings.labels.newProduct && _vm.isNew
                ? _c("div", { staticClass: "product-tile__badge--new" }, [
                    _vm._v("new")
                  ])
                : _vm.product.settings.labels.bestSeller && _vm.isBestseller
                ? _c(
                    "div",
                    { staticClass: "product-tile__badge--bestseller" },
                    [_vm._v("best seller")]
                  )
                : _vm.product.settings.labels.custom &&
                  _vm.hasCustomBadge != null
                ? _c("div", {
                    staticClass: "product-tile__badge--custom",
                    domProps: { innerHTML: _vm._s(_vm.hasCustomBadge) }
                  })
                : _vm._e()
            ])
          : _vm._e(),
        _c("img", {
          staticClass: "product-tile__image",
          attrs: { src: _vm.getDefaultImage, alt: _vm.product.title }
        }),
        _c("transition", { attrs: { name: "fade" } }, [
          _vm.hovered && _vm.$mq !== "mobile"
            ? _c(
                "div",
                {
                  staticClass: "product-tile__image-background",
                  style: `background-image: url(${_vm.getHoverBackgroundImage})`,
                  attrs: { role: "img" }
                },
                [
                  _c("div", {
                    staticClass: "product-tile__image-foreground",
                    style: `background-image: url(${_vm.getHoverForegroundImage})`,
                    attrs: { role: "img" }
                  }),
                  _vm.hovered && _vm.$mq !== "mobile"
                    ? _c(
                        "a",
                        {
                          staticClass: "product-tile__cta",
                          attrs: { href: _vm.url, "aria-label": "Add to Cart" }
                        },
                        [_vm._v("Add to Cart")]
                      )
                    : _vm._e()
                ]
              )
            : _vm._e()
        ])
      ],
      1
    ),
    _c("div", { staticClass: "product-tile__info" }, [
      _vm.product.title
        ? _c("h3", {
            staticClass: "product-tile__title",
            domProps: { innerHTML: _vm._s(_vm.product.title) }
          })
        : _vm._e(),
      _vm.product.excerpt
        ? _c("p", {
            staticClass: "product-tile__excerpt",
            domProps: { innerHTML: _vm._s(_vm.product.excerpt) }
          })
        : _vm._e(),
      _c("p", { staticClass: "product-tile__price" }, [
        _vm.comparePrice
          ? _c("span", { staticClass: "product-tile__price--compare" }, [
              _vm._v(_vm._s(_vm.comparePrice))
            ])
          : _vm._e(),
        _vm.comparePrice
          ? _c("span", { staticClass: "product-tile__price--divider" }, [
              _vm._v("|")
            ])
          : _vm._e(),
        _vm.price
          ? _c("span", {
              staticClass: "product-tile__price--sale",
              domProps: { innerHTML: _vm._s(_vm.price) }
            })
          : _vm._e()
      ])
    ]),
    _vm.product.variants_count > 1
      ? _c(
          "div",
          { staticClass: "product-tile__swatches" },
          _vm._l(_vm.colorVariantProducts, function(variant) {
            return _c(
              "a",
              {
                key: variant.id,
                staticClass: "product-tile__swatch",
                class: { active: _vm.activeVariant == variant.id },
                style: `background-color: ${variant.color_swatch}`,
                attrs: {
                  href: "#",
                  "aria-label": `${_vm.product.title} ${variant.title}`
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.updateVariantProduct(variant.id)
                  }
                }
              },
              [_c("icon", { attrs: { name: "diamond-fill", size: "12px" } })],
              1
            )
          }),
          0
        )
      : _vm._e(),
    _vm.$mq === "mobile"
      ? _c(
          "a",
          {
            staticClass: "product-tile__cta product-tile__cta--mobile",
            attrs: { href: _vm.url, "aria-label": "Add to Cart" }
          },
          [_vm._v("Add to Cart")]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }